import React from 'react';
import { prettyDate } from '../../utils/strings';
import { Space } from '../utils/utils';
import styles from './timeline.module.scss';
import { IoCloudDownload } from 'react-icons/io5';
import { downloadActionDocument } from '../../network/measure';
import { downloadLitigationDocument } from '../../network/litigii';
import { types_TermPeriods } from '../../types/litigations';

const CLitigationTimeline = (props: any) => {
  const { documents } = props;

  const getTerm = (document: any) =>
    'Termen: ' +
    document.term +
    ' ' +
    types_TermPeriods
      .find(t => t.key === document.termPeriod)
      ?.name.toLowerCase();

  return (
    <div className={styles.timeline}>
      {documents && documents.length === 0 && (
        <p className={`body-dark bold`}>Momentan nu există niciun document.</p>
      )}
      {documents && documents.length > 0 && (
        <p className='subheading-dark bold'>Istoric documente adăugate</p>
      )}
      {documents && documents.length > 0 && <Space vertical='5vh' />}
      {documents &&
        documents.map((document: any, index: number) => (
          <div className={styles.line} key={index}>
            <p>
              <span className='body-dark bold'>
                {index % 2 === 0
                  ? document.name
                  : prettyDate(document.documentCommunicationDate)}
              </span>
              <span className='small-dark'>
                <br />
                {index % 2 === 1 ? getTerm(document) : ''}
              </span>
              <br />
            </p>
            <div className='col'>
              <span className={styles.dot}>
                {document.filePath && document.filePath !== '' && (
                  <IoCloudDownload
                    onClick={() =>
                      downloadLitigationDocument(document.id, document.name)
                    }
                  />
                )}
              </span>
              {index < documents.length - 1 && (
                <span className={styles.separator} />
              )}
            </div>
            <p>
              <span className='body-dark bold'>
                {index % 2 === 1
                  ? document.name
                  : prettyDate(document.documentCommunicationDate)}
              </span>
              <span className='small-dark'>
                <br />
                {index % 2 === 0 ? getTerm(document) : ''}
              </span>
            </p>
          </div>
        ))}
      {documents && documents.length > 0 && <Space vertical='5vh' />}
    </div>
  );
};

export default CLitigationTimeline;
